import React from 'react';
import {
  makeStyles, mergeClasses, shorthands,
} from '@fluentui/react-components';

import {
  CheckboxUncheckedRegular,
  CheckboxCheckedFilled,
  RadioButtonRegular,
  RadioButtonFilled,
} from '@fluentui/react-icons';

const useCheckmarkStyles = makeStyles({
  root: {
    '&::before': {
      display: 'block',
      content: '""',
      position: 'absolute',
      boxSizing: 'border-box',
    },
  },
  rootSingle: {
    '&::before': {
      top: '4px',
      left: '4px',
      height: '20px',
      width: '20px',
      ...shorthands.borderRadius('50%'),
      ...shorthands.border('3px', 'solid', 'white'),
    },
  },
  rootMultiple: {
    '&::before': {
      top: '6px',
      left: '6px',
      height: '16px',
      width: '16px',
      ...shorthands.borderRadius('2px'),
      ...shorthands.border('2px', 'solid', 'white'),
    },
  },
  rootSelected: {
    '&::before': {
      backgroundColor: 'white',
    },
  },
  icon: {
    position: 'relative',
    fontSize: '28px',
    color: 'black',
  },
  iconSelected: {
    color: 'rgba(0, 120, 212, 1)',
  },
});

type CheckmarkType = 'single' | 'multiple';

interface ICheckmarkProps {
  type: CheckmarkType;
  selected: boolean;
}

const CheckmarkIcons = {
  single: {
    true: RadioButtonFilled,
    false: RadioButtonRegular,
  },
  multiple: {
    true: CheckboxCheckedFilled,
    false: CheckboxUncheckedRegular,
  },
};

export const Checkmark: React.FC<ICheckmarkProps> = React.memo(({ type, selected }) => {
  const classes = useCheckmarkStyles();

  const Mark = CheckmarkIcons[type][selected.toString() as 'true' | 'false'];

  return (
    <div className={mergeClasses(
      'checkmark',
      classes.root,
      type === 'single' ? classes.rootSingle : classes.rootMultiple,
      selected && classes.rootSelected,
    )}
    >
      <Mark className={mergeClasses(classes.icon, selected && classes.iconSelected)} />
    </div>
  );
});
